import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-departure",
  "use": "icon-departure-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-departure\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#EDF5FF\" /><path fill=\"#437DFF\" fill-rule=\"evenodd\" d=\"M12.72 18.771c1.615-1.063 5.38-3.941 5.38-7.653a6.1 6.1 0 0 0-12.2 0c0 3.712 3.766 6.59 5.38 7.653.44.29 1 .29 1.44 0m-.717-5.525a2.184 2.184 0 1 0 0-4.369 2.184 2.184 0 0 0 0 4.369\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol